const SESSION_CHANGED_KEY = 'larimar.auth.sessionChangedAt';

export function announceSessionChange(): void {
  localStorage.setItem(SESSION_CHANGED_KEY, new Date().toISOString());
}

export function onSessionChangeFromOtherTab(handler: () => void): () => void {
  function listener(event: StorageEvent) {
    if (event.key === SESSION_CHANGED_KEY) {
      handler();
    }
  }
  window.addEventListener('storage', listener);
  return () => window.removeEventListener('storage', listener);
}
